<textarea
  [maxlength]="maxlength"
  class="form-control"
  [id]="id"
  [formControl]="control"
  (blur)="onTouched($event)"
  [placeholder]="placeholder"
  [cols]="dimensions?.cols || DEFAULT_DIMENSIONS.cols"
  [rows]="dimensions?.rows || DEFAULT_DIMENSIONS.rows">
</textarea>
